import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.976 2.25a.7.7 0 0 0-.7.7v.8h-3.6a.7.7 0 0 0-.7.7v16.6a.7.7 0 0 0 .7.7h16.6a.7.7 0 0 0 .7-.7v-3.5a.7.7 0 1 0-1.4 0v2.8h-15.2V5.15h2.9v.8a.7.7 0 0 0 .7.7h8a.7.7 0 0 0 .7-.7v-.8h2.9v1.9a.7.7 0 1 0 1.4 0v-2.6a.7.7 0 0 0-.7-.7h-3.6v-.8a.7.7 0 0 0-.7-.7h-8Zm7.3 1.4h-6.6v1.6h6.6v-1.6Zm-7.3 6.15a.7.7 0 0 0 0 1.4h5.5a.7.7 0 1 0 0-1.4h-5.5Zm0 3a.7.7 0 1 0 0 1.4h2.5a.7.7 0 1 0 0-1.4h-2.5Zm0 3a.7.7 0 1 0 0 1.4h2a.7.7 0 1 0 0-1.4h-2Zm12.07-6.465a.7.7 0 0 1 .982.12l1.847 2.364a.7.7 0 0 1-.12.983l-6.381 4.985a.7.7 0 0 1-.434.148l-2.423-.01a.7.7 0 0 1-.677-.867l.576-2.353a.7.7 0 0 1 .249-.385l6.38-4.985Zm.31 1.534-5.638 4.405-.307 1.255 1.292.005 5.638-4.404-.985-1.261Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
